var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tickets-table',{attrs:{"status":_vm.status,"priority":_vm.priority,"title-heading":"h2","owner-id":_vm.ownerId,"bottom-comp":_vm.bComp,"bottom-comp-props":_vm.bCompProps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }